import { TableTemplate } from 'types/tableTemplate';

export const specialtyTableTemplate: TableTemplate[] = [
  {
    id: 'id',
    description: 'ID',
    originalId: 'id',
    width: 80,
  },
  {
    id: 'name',
    description: 'Nome',
    originalId: 'name',
    width: 300,
  },
  {
    id: 'deleteAction',
    description: 'Ações',
    originalId: 'deleteAction',
    width: 40,
    notFilterable: true,
    notSearchable: true,
  },
];
